import * as React from 'react';
import { FormField, Container, Row, Col, TextButton, Text, InputArea } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { TextAndStylePrivacyInfoMaxLength } from '@src/constants/constants';
import { TranslationKey } from '@src/types';

import * as css from '@src/components/global.scss';

const MAX_LEN = TextAndStylePrivacyInfoMaxLength;

interface Props extends InjectedTranslateProps {
  value: string;
  disabled: boolean;
  learnMoreKBLink: string;
  onChange: (value: string) => void;
}

interface State {
  privacyPolicyInfoTextLength: number;
}

class PrivacyInfoEditorBase extends React.PureComponent<Props, State> {
  onValueChange = (event: any) => {
    const text = event.target.value;

    if (text.length <= MAX_LEN) {
      this.props.onChange(text);
    }
  };

  onRestorePrivacyInfo = () => this.props.onChange(this.props.t(`site:${TranslationKey.PrivacyInfo}`));
  onNoteLearnMoreClicked = () => window.open(this.props.learnMoreKBLink, '_blank');

  render() {
    const { t, value, disabled } = this.props;

    return (
      <Container fluid>
        <Row className={css.rowBeforeRestoreButton}>
          <Col span={12}>
            <FormField
              label={t('text-and-display.info-text-settings.subtitle')}
              charCount={MAX_LEN - (value?.length || 0)}
            >
              <InputArea
                dataHook={DataHooks.TextAndDisplayPrivacyInfo}
                value={value}
                minHeight={'107px'}
                onChange={this.onValueChange}
                disabled={disabled}
              />
            </FormField>
          </Col>
        </Row>
        <Row>
          <Col>
            <TextButton
              size="tiny"
              dataHook={DataHooks.TextAndDisplayPrivacyRestore}
              onClick={this.onRestorePrivacyInfo}
            >
              {t('text-and-display.info-text-settings.restore-default')}
            </TextButton>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Text size="tiny">
              {t('text-and-display.info-text-settings.note')}{' '}
              <TextButton size="tiny" onClick={this.onNoteLearnMoreClicked}>
                {t('learn.more')}
              </TextButton>
            </Text>
          </Col>
        </Row>
      </Container>
    );
  }
}

export const PrivacyInfoEditor = translate()(PrivacyInfoEditorBase);
